enum ActionTypes {
  GET_TICKET_TYPES_LIST = 'app/CustomerSupport/GET_TICKET_TYPES_LIST',
  CUSTOMER_SUPPORT_LIST_SUCCESS = 'app/CustomerSupport/CUSTOMER_SUPPORT_LIST_SUCCESS',
  FETCH_TICKET_TYPES_BY_ID = 'app/CustomerSupport/FETCH_TICKET_TYPES_BY_ID',
  EDIT_SAVE_CUSTOMER_SUPPORT = 'app/CustomerSupport/EDIT_SAVE_CUSTOMER_SUPPORT',
  SET_CUSTOMER_SUPPORT_LOADER = 'app/CustomerSupport/SET_CUSTOMER_SUPPORT_LOADER',
  SET_SORT_BY = 'app/CustomerSupport/SET_SORT_BY',
  SET_CUSTOMER_SUPPORT_DETAIL = 'app/CustomerSupport/SET_CUSTOMER_SUPPORT_DETAIL',
}

export default ActionTypes;
